import React, { createContext, useContext, useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

type ToastItem = { id: string; title: string; body?: string };

type ToastCtx = { push: (t: Omit<ToastItem,'id'>) => void };

const Ctx = createContext<ToastCtx | null>(null);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);

  function push(t: Omit<ToastItem,'id'>) {
    const id = crypto.randomUUID();
    const item = { id, ...t };
    setItems(prev => [item, ...prev].slice(0, 3));
    window.setTimeout(() => setItems(prev => prev.filter(x => x.id !== id)), 4000);
  }

  const value = useMemo(() => ({ push }), []);
  return (
    <Ctx.Provider value={value}>
      {children}
      <div className="toastWrap">
        <AnimatePresence>
          {items.map(t => (
            <motion.div
              key={t.id}
              className="toast"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              <div style={{ fontWeight: 800 }}>{t.title}</div>
              {t.body ? <div className="small" style={{ marginTop: 4 }}>{t.body}</div> : null}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </Ctx.Provider>
  );
}

export function useToast() {
  const v = useContext(Ctx);
  if (!v) throw new Error('useToast fuori da ToastProvider');
  return v;
}
